import { type ReactElement } from 'react'
import ExclamationCircleIcon from '../icons/ExclamationCircleIcon'

export function ErrorDisplay ({ error, tid }: { error: string, tid?: string }): ReactElement {
  return (
    <div className="flex justify-start items-center" data-tid={tid}>
      <ExclamationCircleIcon />
      <div className="text-red-400 text-sm">&nbsp;{error}</div>
    </div>
  )
}
